import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import * as videoActions from 'action/video'
import { isEmpty } from 'utils/validations'
import ContentHeader from 'component/utils/ContentHeader'
import VideosEditForm from 'component/video/EditForm'
import VideosTable from 'component/video/Table'
import Notification from 'component/utils/Notification'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Pagination from 'component/pagination/Pagination'
import Breadcrumb from 'component/Breadcrumb'
import firebase from 'utils/Firebase'

class VideosContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    error: PropTypes.object,
    updated: PropTypes.bool,
    removed: PropTypes.bool,
    record: PropTypes.object,
    videos: PropTypes.array.isRequired,
    update: PropTypes.func.isRequired,
    fetchVideos: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired,
    removeAll: PropTypes.func.isRequired,
    pages: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
  }

  state = {
    formVisible: true,
    tableVisible: true,
    renderButtons: false,
  }

  componentDidMount() {
    /* istanbul ignore else */
    if (window.innerWidth <= 768) {
      this.setState({ formVisible: false })
    }

    this.handleFetchVideos()
  }

  componentWillReceiveProps() {
    const { formVisible } = this.state
    const { updated } = this.props

    /* istanbul ignore else */
    if (formVisible && updated) {
      this.invertStates()
    }
  }

  invertStates = () => {
    /* istanbul ignore else */
    if (window.innerWidth > 768) {
      return this.setState({ formVisible: true, tableVisible: true })
    }

    this.setState((state) => ({
      formVisible: !state.formVisible,
      tableVisible: !state.tableVisible,
    }))
  }

  handleFetchVideos = (page) => {
    const {
      fetchVideos,
      auth: { user },
    } = this.props

    fetchVideos(user.dsToken, page)
  }

  handleSubmit = (toSave, callbackOnSuccess) => {
    const {
      update,
      auth: { user },
    } = this.props

    update(user.dsToken, toSave, callbackOnSuccess)
  }

  handleRemoveAll = (lsToRemove) => {
    const {
      removeAll,
      auth: { user },
    } = this.props

    // Creates a root reference
    const storage = firebase.storage()

    lsToRemove.forEach((item) => {
      item.idVideo = item.videoId
      /* istanbul ignore else */
      if (item && item.videoUrl) {
        const fileReference = storage.refFromURL(item.videoUrl)
        fileReference.delete()
      }
    })

    removeAll(user.dsToken, lsToRemove)
  }

  handleRemove = (toRemove) => {
    const {
      remove,
      auth: { user },
    } = this.props

    // Creates a root reference
    const storage = firebase.storage()

    /* istanbul ignore else */
    if (toRemove && toRemove.videoUrl) {
      const fileReference = storage.refFromURL(toRemove.videoUrl)

      fileReference
        .delete()
        .then(() => {
          remove(user.dsToken, toRemove)
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }

  setRenderButtons = (value) => {
    this.setState({ renderButtons: value })
  }

  renderNotification = () => {
    const { translate } = this.props
    return (
      <Notification
        className='notification-warning notification-warning-mission margin-top'
        message={translate('mobile-update.not-found')}
      />
    )
  }

  renderUpdateNotification = () => {
    const { translate } = this.props

    return (
      <Notification
        className='notification-success margin-top'
        message={translate('video.update-success')}
      />
    )
  }

  renderRemoveNotification = () => {
    const { translate } = this.props

    return (
      <Notification
        className='notification-success margin-top'
        message={translate('video.remove-success')}
      />
    )
  }

  renderFieldsErrors = (fields) => (
    <li className='margin-left' key={fields.naField}>
      {fields.naField ? `${fields.naField}:` : ''} {fields.dsDetail}
    </li>
  )

  renderBreadcrumb = () => {
    const { translate } = this.props

    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('videos.title') },
    ]

    return <Breadcrumb steps={steps} />
  }

  render() {
    const {
      translate,
      error,
      videos,
      pages,
      count,
      current,
      updated,
      removed,
      record,
      auth,
    } = this.props

    const { tableVisible, formVisible, renderButtons } = this.state

    let initialValues = {}
    /* istanbul ignore else */
    if (record) {
      initialValues = record
    }

    return (
      <section className='video-page'>
        <ContentHeader>{translate('videos.title')}</ContentHeader>

        <section>
          {this.renderBreadcrumb()}

          <div className='container-fluid'>
            {
              // shows notification after an update
              error && error.fields ? (
                <div className='margin-top margin-botton notification notification-warning'>
                  {error.fields.map(this.renderFieldsErrors)}
                </div>
              ) : error ? (
                <div className='margin-top margin-botton notification notification-warning'>
                  {error.message.dsMessage}
                </div>
              ) : (
                ''
              )
            }
          </div>

          <Row className='container-mobile container-flex'>
            {formVisible && (
              <Col xs={12} sm={12} md={4} className='show-fourth-on-mobile'>
                <VideosEditForm
                  translate={translate}
                  onSubmit={this.handleSubmit}
                  initialValues={initialValues}
                  error={error}
                  auth={auth}
                  invertStates={this.invertStates}
                />
              </Col>
            )}

            {tableVisible && (
              <Col xs={12} sm={12} md={8} className='show-first-on-mobile'>
                {updated && this.renderUpdateNotification()}
                {removed && this.renderRemoveNotification()}

                {isEmpty(videos) ? (
                  this.renderNotification()
                ) : (
                  <VideosTable
                    translate={translate}
                    videos={videos}
                    renderButtons={renderButtons}
                    setRenderButtons={this.setRenderButtons}
                    handleRemove={this.handleRemove}
                    handleRemoveAll={this.handleRemoveAll}
                    onSubmit={this.handleSubmit}
                    user={auth.user}
                  />
                )}
              </Col>
            )}

            {pages > 1 && tableVisible && (
              <Col className='show-second-on-mobile align-center margin-top margin-bottom-double'>
                <div className='align-center'>
                  <Pagination
                    getPage={this.handleFetchVideos}
                    pages={pages}
                    current={current}
                    count={count}
                  />
                </div>
              </Col>
            )}
          </Row>
        </section>
      </section>
    )
  }
}

/*
 * Maps redux state to component props
 */
/* istanbul ignore next */
const mapStateToProps = ({ videosReducer, paginateReducer }) => ({
  videos: videosReducer.list.records,
  updated: videosReducer.edit.updated,
  removed: videosReducer.edit.removed,
  error: videosReducer.edit.error,
  record: videosReducer.edit.record,
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
})

/*
 * Maps actions and dispatch them to component props
 */
/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(videoActions, dispatch)

/*
 * Connects component to I18next
 */
/* istanbul ignore next */
const VideosTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(VideosContainer)

/*
 * Exports component connected to redux as default
 */

export default connect(mapStateToProps, mapDispatchToProps)(VideosTranslated)

/*
 * Exports as component
 */
export { VideosContainer as Videos }
